import { render } from "./MyDelivery.vue?vue&type=template&id=0a68bea7"
import script from "./MyDelivery.vue?vue&type=script&lang=js"
export * from "./MyDelivery.vue?vue&type=script&lang=js"
script.render = render

export default script